
















import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import * as ModalStore from "@app/shared/modals/stores/modalStore";
import ModalState = Modals.ModalState;

@Component
export default class ModalContainer extends Vue {

    constructor() {
        super();
    }

    get modals(): any {
        return this.$store.state.modalStore;
    }

    close(modalId: number): void {
        ModalStore.close(this.$store, modalId);
    }
}
